import React from 'react';
import classes from './style.module.css'
import ApplicationLogin from '../../components/ApplicationLogin'
import { Container, Row } from 'react-bootstrap';
import BannerRow from "../BannerRow"
import HeaderRow from "../HeaderRow"
import BottomRow from "../BottomRow"
import advertisementImage from "../../assets/images/advertisement.jpg"
import headerImage from '../../assets/images/header.png'


const LoginView = (props) => {

    const advertisementStyle = {
        margin: '8px 0 10px 0',
        textAlign: 'center',
        width: '100%'
    }

    return (
        <Container className={classes.LoginView} fluid>
            <BannerRow bannerImage={headerImage} />
            <HeaderRow active={false} />
            <Row className={classes.MiddleRow}>
                <ApplicationLogin />
            </Row>
            <div style={advertisementStyle}>
                <BannerRow bannerImage={advertisementImage} desturl="http://football-atm.com/ms.htm" />
            </div>
            <BottomRow />
        </Container>
    );
}

export default LoginView;